export const testVar = process.env.REACT_APP_TEST_VAR